export const sessionStorageService = {
  set: (key: string, value: unknown) => {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch (err) {
      console.error(`Error saving to sessionStorage [${key}]`, err);
    }
  },

  get: <T = unknown>(key: string): T | null => {
    try {
      const item = sessionStorage.getItem(key);
      return item ? (JSON.parse(item) as T) : null;
    } catch (err) {
      console.error(`Error reading from sessionStorage [${key}]`, err);
      return null;
    }
  },

  remove: (key: string) => {
    try {
      sessionStorage.removeItem(key);
    } catch (err) {
      console.error(`Error removing from sessionStorage [${key}]`, err);
    }
  },
};
